const inlineFilterItems = [
  {
    id: 'all',
    label: "costManagement.status.all",
  },
  {
    id: "DRAFT",
    label: "costManagement.status.draft",
  },
  {
    id: "CONFIRMED",
    label: "costManagement.status.confirmed",
  },
]

export default inlineFilterItems